import React, { useEffect, useState } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  chakra,
  Flex,
  Box,
  Button,
  Heading,
  Text,
} from '@chakra-ui/react';
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
} from 'react-table';
import GlobalFilter from 'components/pages/ManajemenUser/GlobalFilter';
import Pagination from 'components/pages/ManajemenUser/Pagination';
import { useNavigate } from 'react-router-dom';
import ContentLayout from 'components/layout/ContentLayout';
import moment from 'moment';
import { getListLayananDietela } from 'utils/axios.services';
import ResponseDialog from 'components/common/ResponseDialog';

export default function ManajemenAdmin() {
  const navigate = useNavigate();
  const [dataLayananDietela, setDataLayananDietela] = useState([]);

  const data = React.useMemo(() => dataLayananDietela, [dataLayananDietela]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'id',
      },
      {
        Header: 'Judul',
        accessor: 'judul',
      },
      {
        Header: 'Isi',
        accessor: 'isi',
      },
      {
        Header: 'Button Link',
        accessor: 'link',
      },
      {
        Header: 'Action',
        Cell: ({ row }) => (
          <Button
            px="6"
            variant="outline"
            colorScheme="teal"
            borderRadius="full"
            onClick={() => {
              navigate(`detail/${row.values.id}`);
            }}
          >
            Lihat
          </Button>
        ),
      },
    ],
    [navigate]
  );

  useEffect(() => {
    getListLayananDietela().then(res => {
      setDataLayananDietela(res.data.data);
    });
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    nextPage,
    previousPage,
    setPageSize,
    gotoPage,
    state,
  } = useTable({ columns, data }, useGlobalFilter, useSortBy, usePagination);

  const routes = [
    {
      name: 'Manajemen Layanan Dietela',
    },
  ];

  return (
    <ContentLayout routes={routes}>
      <ResponseDialog
        dialogImageUrl="https://nama-storage.ap-south-1.linodeobjects.com/berhasil_simpandata.png"
        DialogText="Data berhasil dihapus!"
        BtnDialogText="Selesai"
      />
      <Flex
        justifyContent="space-between"
        alignItems={{
          base: 'start',
          md: 'center',
        }}
        mb="8"
        gap="5"
        minH="50px"
        flexDirection={{
          base: 'column',
          md: 'row',
        }}
      >
        <Heading fontSize="28">Manajemen Layanan Dietela</Heading>
        {/* <Button
          py="6"
          px="8"
          borderRadius="full"
          leftIcon={<AddIcon />}
          color="#695100"
          bg="dietela.secondary-variant"
          _hover={{
            bg: 'dietela.secondary',
          }}
          _focus={{
            bg: 'dietela.secondary-variant',
          }}
          onClick={() => {
            navigate('tambah-admin');
          }}
        >
          Tambah Admin
        </Button> */}
      </Flex>
      <Box bgColor="white" borderRadius="1rem" overflowX="auto">
        <Flex
          justifyContent="space-between"
          alignItems="center"
          w="100%"
          py="3"
          px="5"
        >
          <Heading fontWeight="semibold" fontSize="lg">
            List of Layanan Dietela
          </Heading>
          <GlobalFilter
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
          />
        </Flex>
        <Table {...getTableProps()}>
          <Thead backgroundColor="teal.100">
            {headerGroups.map(headerGroup => (
              <Tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    color="teal.800"
                    fontWeight="semibold"
                  >
                    {column.render('Header')}
                    <chakra.span pl="4">
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <TriangleDownIcon aria-label="sorted descending" />
                        ) : (
                          <TriangleUpIcon aria-label="sorted ascending" />
                        )
                      ) : null}
                    </chakra.span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()}>
                  {row.cells.map(cell => (
                    <Td {...cell.getCellProps()}>
                      {cell.column.id === 'updatedAt' ? (
                        <>
                          <Text>{moment(cell.value).format('DD-MM-YYYY')}</Text>
                          <Text fontSize="sm" color="#888888" mt="2">
                            {moment(cell.value).fromNow()}
                          </Text>
                        </>
                      ) : (
                        <Text>{cell.render('Cell')}</Text>
                      )}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>

        <Pagination
          pageSize={state.pageSize}
          pageCount={pageCount}
          setPageSize={setPageSize}
          pageIndex={state.pageIndex}
          pageOptions={pageOptions}
          canNextPage={canNextPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          previousPage={previousPage}
          gotoPage={gotoPage}
        />
      </Box>
    </ContentLayout>
  );
}
